import { api } from '@/lib/api';
import type { DiscoveryFilters, DiscoveryListResponse, VendorDetail } from './types';

export async function fetch_vendors(filters: DiscoveryFilters): Promise<DiscoveryListResponse> {
  const params: Record<string, string | number> = {};
  if (filters.module) params.module = filters.module;
  if (filters.q) params.q = filters.q;
  if (filters.city) params.city = filters.city;
  if (filters.page) params.page = filters.page;
  if (filters.lat != null && filters.lng != null) {
    params.lat = filters.lat;
    params.lng = filters.lng;
    if (filters.radius_km != null) params.radius_km = filters.radius_km;
  }
  // CREMATION-only filters.
  if (filters.home_pickup) params.home_pickup = 'true';
  if (filters.emergency) params.emergency = 'true';
  if (filters.cremation_service_type) params.cremation_service_type = filters.cremation_service_type;
  // LAB-only filters.
  if (filters.home_collection) params.home_collection = 'true';
  if (filters.lab_sample_type) params.lab_sample_type = filters.lab_sample_type;
  const res = await api.get<DiscoveryListResponse>('/user/vendors', { params });
  return res.data;
}

/**
 * Coordinates are optional but worth sending: with them the server fills in
 * `distance_km` on the vendor AND on every service, so a service card can say
 * how far away it is. Send both or neither — one alone is a 422.
 */
export async function fetch_vendor(id: string, coords?: { lat: number; lng: number }): Promise<VendorDetail> {
  const params = coords ? { lat: coords.lat, lng: coords.lng } : undefined;
  const res = await api.get<VendorDetail>(`/user/vendors/${id}`, { params });
  return res.data;
}
